import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'

// success: #3f4fa6, error: #c7435d

export default new Notyf({
  types: [{
    type: 'success',
    backgroundColor: '#3f4fa6'
  }, {
    type: 'error',
    backgroundColor: '#c7435d'
  }]
})
